import React from "react";

import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";

import { CancelCallModalProps } from "../../types/CancelCallModalProps";

export default function CancelCallModal({
  isVisible,
  onConfirm,
  onClose,
  translate,
}: CancelCallModalProps) {
  const footerContent = (
    <div className="flex flex-row gap-x-2 justify-end">
      <button
        onClick={onConfirm}
        // className="px-4 py-2 rounded-3xl text-svvh-green bg-white border border-svvh-green hover:bg-svvh-light-green w-[180px] mt-4"
        className="px-4 py-2 rounded-3xl text-svvh-green gold-submit-btn-outlined w-[180px] mt-4"
      >
        {translate("pages.waitingCall.cancelCallModal.buttons.leaveMessage")}
      </button>
      <button
        onClick={onClose}
        // className="px-4 py-2 rounded-3xl text-white w-[200px] bg-svvh-green hover:bg-green-700 mt-4"
        className="px-4 py-2 rounded-3xl text-white w-[200px] gold-submit-btn mt-4"
      >
        {translate("pages.waitingCall.cancelCallModal.buttons.waitForCall")}
      </button>
    </div>
  );

  return (
    <div className="font-prompt flex justify-content-center">
      <Dialog
        header={
          <div className="w-full text-center font-semibold text-xl sm:text-2xl">
            {translate("pages.waitingCall.cancelCallModal.title")}
          </div>
        }
        visible={isVisible}
        position={"top"}
        onHide={onClose}
        footer={footerContent}
        draggable={false}
        resizable={false}
        closable={false}
        style={{ width: "100%", maxWidth: "800px" }}
      >
        <div className="flex flex-col text-center text-md sm:text-lg">
          <div className="border boder-t-2 mb-6"></div>
          <span>{translate("pages.waitingCall.cancelCallModal.text1")}</span>
          <span>{translate("pages.waitingCall.cancelCallModal.text2")}</span>
        </div>
      </Dialog>
    </div>
  );
}
